import "../scss/styles.scss";
import InitPano from "./engine/InitPano.js"

export default class FactoryManager {

	static factory(cls,...rest) {
		return new FactoryManager.classes[cls](rest);
	}

}

FactoryManager.classes = { InitPano }; 